<template>
  <div id="home">
    <v-container fluid>
      <core-app-view />
      <v-row>
        <v-col cols="12">
          <v-parallax src="../assets/bg_sc.jpeg">
            <div>
              <v-row
                style="margin-top: -10vh"
                align="center"
                no-gutters
                justify="center"
              >
                <v-col offset="1" cols="6" class="pa-0">
                  <v-row no-gutters justify="center" align="center">
                    <v-col cols="3" class="mb-4 text-end pa-0 justify-end">
                      <v-img
                        :src="require('../assets/serc_logo.png')"
                        class="my-3"
                        contain
                        height="20"
                      ></v-img>
                    </v-col>
                    <v-col cols="9" class="pa-0 justify-start text-start">
                      <h1 class="display-1  mb-4" style="color: white">
                        체감형 가상과학관 기반기술
                      </h1>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="text-center" cols="12">
                  <h4 class="subheading">
                    click to see demos & get free downloads
                  </h4>
                </v-col>
              </v-row>
            </div>
          </v-parallax>
        </v-col>
      </v-row>
      <v-row style="margin-top: -15vh" align="center" justify="space-around">
        <v-col cols="3">
          <v-card
            outlined
            dark
            ripple
            color="#595649"
            class="mx-auto"
            onclick="location.href='/smc/sketchscope'"
          >
            <div
              style="margin-top: 2vh; margin-bottom: 2vh"
              class="text-center"
              align="center"
              justify="center"
            >
              <h5 style="font-size:1vw;" class="text-h6 font-weight-light ">
                SketchScope: Basic
              </h5>
            </div>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card
            outlined
            dark
            ripple
            color="#595649"
            class="mx-auto"
            onclick="location.href='/smc/motion_recognition'"
          >
            <div
              style="margin-top: 2vh; margin-bottom: 2vh"
              class="text-center"
              align="center"
              justify="center"
            >
              <h5 class="text-h6 font-weight-light ">
                SketchScope: Motion Recognition
              </h5>
            </div>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card
            outlined
            dark
            ripple
            color="#595649"
            class="mx-auto"
            onclick="location.href='/smc/ar'"
          >
            <div
              style="margin-top: 2vh; margin-bottom: 2vh"
              class="text-center"
              align="center"
              justify="center"
            >
              <h5 class="text-h6 font-weight-light ">
                SketchScope: Augmented Reality
              </h5>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-card flat class="mx-auto align-center pa-4" style="margin-top: 40px">
          <v-row
            style="padding-left: 5%; padding-right: 5%"
            align="center"
            justify="center"
          >
            <v-col style="padding-top: 1vh">
              <body class="body-1">
                {{ about.data }}
              </body>
            </v-col>
          </v-row>
          <v-row
            style="padding-left: 5vw; padding-right: 5vw; padding-top: 1vh"
          >
            <v-col>
              <h1 class="font-weight-light">
                본 기술을 통해 제작된 시범콘텐츠
              </h1>
            </v-col>
          </v-row>
          <v-row
            style="padding-left: 7vw; padding-right: 5vw; padding-top: 2vh"
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <h2 class="font-weight-thin">나는 우리나라 미라과학자</h2>
            </v-col>
            <v-col style="padding-top: 2vh" cols="8">
              <body class="body-1">
                {{ about.data1 }}
              </body>
            </v-col>
            <v-col cols="4">
              <v-img src="@/assets/타이틀.png" />
            </v-col>
          </v-row>
          <v-row
            style="padding-left: 7vw; padding-right: 5vw; padding-top: 2vh"
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <h2 class="font-weight-thin">미라의 몸 속은 어떻게 생겼을까?</h2>
            </v-col>
            <v-col cols="8" style="padding-top: 2vh">
              <body class="body-1">
                {{ about.data2 }}
              </body>
            </v-col>
            <v-col cols="4">
              <v-img
                sizes="(max-width: 320px) 100vw,
                                (max-width: 480px) 100vw,
                                800px"
                src="@/assets/사진1.png"
              >
              </v-img>
            </v-col>
          </v-row>
          <v-row
            style="padding-left: 7vw; padding-right: 5vw; padding-top: 2vh"
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <h2 class="font-weight-thin">
                미라의 머리 속은 어떻게 생겼을까?
              </h2>
            </v-col>
            <v-col style="padding-top: 2vh" cols="8">
              <body class="body-1">
                {{ about.data3 }}
              </body>
            </v-col>
            <v-col cols="4">
              <v-img src="@/assets/사진2.png"></v-img>
            </v-col>
          </v-row>
          <v-row
            style="padding-left: 7vw; padding-right: 5vw; padding-top: 2vh"
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <h2 class="font-weight-thin">미라의 발굴</h2>
            </v-col>
            <v-col style="padding-top: 2vh" cols="8">
              <body class="body-1">
                {{ about.data4 }}
              </body>
            </v-col>
            <v-col cols="4">
              <v-img src="@/assets/사진3.png"></v-img>
            </v-col>
          </v-row>

          <v-row
            style="padding-left: 7vw; padding-right: 5vw; padding-top: 2vh"
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <h2 class="font-weight-thin">데모 동영상</h2>
            </v-col>
            <v-col style="padding-top: 2vh" cols="12">
              <body class="body-1">
                {{ about.data5 }}
              </body>
            </v-col>
            <v-col cols="12">
              <video controls width="100%" style="margin-bottom: 10vh;">
                <source src="@/assets/미라과학자_demo.mp4" type="video/mp4" />

                Sorry, your browser doesn't support embedded videos.
              </video>
            </v-col>
          </v-row>

          <v-row
            style="padding-left: 7vw; padding-right: 5vw; padding-top: 2vh"
            align="center"
            justify="center"
          >
            <v-col style="padding-top: 4vh; text-align: center" cols="12">
              <body class="body-1">
                본 콘텐츠는 양방향 멀티모달 상호작용을 지원하는 체감형
                가상과학관 플랫폼 구축과제에 대한 연구결과로
              </body>
              <body class="body-1">
                과학문화전시서비스역량강화지원사업의 지원을 받아 제작되었습니다.
              </body>
            </v-col>
          </v-row>

          <v-card flat height="150px"></v-card>
          <v-fab-transition>
            <v-btn
              absolute
              fab
              small
              dark
              color="cyan"
              bottom
              right
              onclick="location.href='#'"
            >
              <v-icon>{{ icons.mdiArrowUp }}</v-icon>
            </v-btn>
          </v-fab-transition>
        </v-card>
      </v-row>
      <core-footer />
    </v-container>
  </div>
</template>

<script>
import { mdiArrowUp } from "@mdi/js";
import { data, data1, data2, data3, data4, data5 } from "@/data/about.js";
export default {
  name: "Home",
  data: () => ({
    icons: {
      mdiArrowUp,
    },
    about: {
      data,
      data1,
      data2,
      data3,
      data4,
      data5,
    },
  }),
  components: {
    CoreAppView: () => import("@/components/core/AppView"),
    CoreFooter: () => import("@/components/core/Footer"),
  },
};
</script>
